import {
  Icon,
  IconButton,
  LinearProgress,
  Stack,
  Tooltip,
} from "@mui/material";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import { useState } from "react";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import MDTypography from "components/MDTypography";
import DeleteDialog from "components/UIComponents/DeleteDialog";
import { deleteUser } from "store/slice/users/userSlice";
import { useDispatch } from "react-redux";
import { userStatusUpdate } from "store/slice/users/userSlice";
import MDSwitch from "components/MDSwitch";
import CreateUser from "./CreateUser";
import { useMaterialUIController } from "context";
import { switchUser, logout } from "store/slice/auth/authSlice";
import { useNavigate } from "react-router-dom";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";

const UserTable = (props) => {
  const { userData, updateParentData, roleModules } = props;
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editUserData, setEditUserData] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userId, setUserId] = useState([]);
  const [toggleLoading, setToggleLoading] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });

  const handelDelete = () => {
    dispatch(deleteUser({ userId }))
      .unwrap()
      .then(async (res) => {
        if (res?.success) {
          updateParentData();
          setDialogOpen(false);
        }
      })
      .catch((err) => console.error("Error deleting user:", err));
  };

  const handleUpdateUser = (userId, type) => {
    const status = type === "ACTIVE" ? 10 : 1;
    setToggleLoading(userId);
    dispatch(userStatusUpdate({ userId, status }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
          updateParentData();
        }
      })
      .catch((err) => console.error("Error updating user:", err))
      .finally(() => setToggleLoading(null));
  };

  const handelSwitch = (data) => {
    setIsLoading(true);
    const { email } = data;
    dispatch(switchUser({ email }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
         let stack = JSON.parse(localStorage.getItem("ImpersonateStack")) || [];


const role = stack.length === 0 
  ? "SUPER_ADMIN"   
  : "BRAND_ADMIN";  

stack.push({
  token: localStorage.getItem("Authorization"),
  role
});

localStorage.setItem("ImpersonateStack", JSON.stringify(stack));
      dispatch(logout());
          localStorage.setItem("Authorization", res?.token);
          navigate("/");
          setIsLoading(false);
        } else {
          setNotification({
            ...notification,
            color: "error",
            title: "Error",
            content: res?.message,
            icon: "warning",
            show: true,
          });
        }
      })
      .catch((err) => console.log("error", err));
  };

  const columnsData = [
    {
      field: "fullName",
      headerName: "Full Name",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {row.firstName.concat(" ", row.lastName)}
        </MDTypography>
      ),
    },
    {
      field: "email",
      headerName: "Email ID",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.email}`}
        </MDTypography>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile No",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {` ${row.mobile}`}
        </MDTypography>
      ),
    },
    {
      field: "roleTitle",
      headerName: "User Role",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography
          display="block"
          variant="caption"
          sx={{ color: "black.light" }}
        >
          {row.roleId?.title}
        </MDTypography>
      ),
    },
    {
      field: "locations",
      headerName: "Locations",
      width: 150,
      renderCell: ({ row }) => (
        <div className="rowscroll">
          {row.locations.map((l) => (
            <MDBadge
              key={l._id || l.parkingCode}
              badgeContent={<p>{l?.parkingCode.toString()}</p>}
              color="secondary"
              variant="gradient"
              size="md"
            />
          ))}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      renderCell: ({ row }) => (
        <>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Tooltip title="Impersonate user" placement="top" arrow>
              <MDButton
                variant="gradient"
                onClick={() => handelSwitch(row)}
                fontSize="small"
                color={sidenavColor}
              >
                <SelfImprovementIcon />
              </MDButton>
            </Tooltip>

            {roleModules.MyUser_update && (
              <Tooltip
                title={row?.status === 10 ? "Disable User" : "Enable User"}
                placement="top"
                arrow
              >
                <MDSwitch
                  disabled={toggleLoading === row._id}
                  checked={row?.status === 10}
                  onChange={() =>
                    handleUpdateUser(
                      row?._id,
                      row?.status === 10 ? "INACTIVE" : "ACTIVE"
                    )
                  }
                />
              </Tooltip>
            )}

            {roleModules.MyUser_update && (
              <Tooltip title="Edit User" placement="top" arrow>
                <IconButton
                  onClick={() => {
                    setUpdateDialogOpen(true);
                    setEditUserData(row);
                  }}
                  color="secondary"
                >
                  <Icon fontSize="small">edit</Icon>
                </IconButton>
              </Tooltip>
            )}

            {roleModules.MyUser_delete && (
              <Tooltip title="Delete User" placement="top" arrow>
                <IconButton
                  onClick={() => {
                    setDialogOpen(true);
                    setUserId(row._id);
                  }}
                  color="error"
                >
                  <Icon fontSize="small">delete</Icon>
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </>
      ),
    },
  ];

  return (
    <>
      <MDDataGrid
        rows={userData ?? []}
        columns={columnsData}
        getRowId={(row) => row?._id}
        pagination
        page={page}
        pageSize={pageSize}
        paginationMode="client"
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        disableSelectionOnClick={true}
        components={{
          NoRowsOverlay: EmptyTableRowOverlay,
          LoadingOverlay: LinearProgress,
        }}
      />
      <DeleteDialog
        dialogOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        handelClick={handelDelete}
      />
      <CreateUser
        editUserData={editUserData}
        dialogOpen={updateDialogOpen}
        onClose={() => setUpdateDialogOpen(false)}
        updateParentData={updateParentData}
      />
    </>
  );
};

export default UserTable;
